import { UrlProvider } from 'urls'

import routeWithLayout from 'components/auth/routeWithLayout'

import Campaign from '../views/campaign/Campaign'
import CampaignEdit from '../views/campaign/CampaignEdit'
import CampaignReview from '../views/campaign/CampaignReview'
import Campaigns from '../views/campaign/Campaigns'
import CampaignsReview from '../views/campaign/CampaignsReview'
import CampaignTargetsMatchSummary from '../views/campaign/CampaignTargetsMatchSummary'

export default [
  routeWithLayout({ main: Campaigns, path: UrlProvider.getRawUrl('campaigns') }),
  routeWithLayout({ main: CampaignsReview, path: UrlProvider.getRawUrl('campaigns.review') }),
  routeWithLayout({ main: CampaignEdit, path: UrlProvider.getRawUrl('campaign.edit') }),
  routeWithLayout({ main: CampaignReview, path: UrlProvider.getRawUrl('campaign.review') }),
  routeWithLayout({ main: Campaign, path: UrlProvider.getRawUrl('campaign') }),
  routeWithLayout({ main: Campaign, path: UrlProvider.getRawUrl('campaign.tab') }),
  routeWithLayout({ main: CampaignTargetsMatchSummary, path: UrlProvider.getRawUrl('campaign.targets.match') }),
]
